if (!customElements.get('cart-delivery-date')) {
  class CartDeliveryDate extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input');
      this.input.id = 'cdd-' + Date.now() + Math.random().toString(36).substring(2, 15);
      this.style.display = 'block';

      this.blockDates = this.getAttribute('block-dates') ? JSON.parse( this.getAttribute('block-dates') ) : [];
      this.minDate = this.getMinDate();

      this.input.setAttribute('min', this.minDate.toISOString().split('T')[0]);
      this.clearDate = this.hasAttribute('clear-date');

      this.styleTag = document.createElement('style');
      this.hasStyleTag = false;

      this.interval = null;
    }

    connectedCallback() {
      // Check for easepick - if it's not loaded, wait and try again
      this.interval = setInterval(() => {
        if (easepick) {
          clearInterval(this.interval);
          this.init();
        }
      }, 200);
    }

    getMinDate() {
      const timezone = this.getAttribute('timezone');
      
      // Use store timezone to calculate offset
      const sign = timezone[0] === '-' ? -1 : 1;
      const [hours, minutes] = timezone.slice(1).split(':').map(Number);
      const offsetMinutes = sign * (hours * 60 + minutes);
      
      const localOffsetMinutes = new Date().getTimezoneOffset();
      const totalOffsetMs = (offsetMinutes + localOffsetMinutes) * 60000;
      
      const minDate = new Date(Date.now() + totalOffsetMs);

      // Set the cutoff time to 3pm
      if (minDate.getHours() >= 15) { 
        minDate.setHours(24, 0, 0, 0);
      } else {
        minDate.setHours(0, 0, 0, 0);
      }

      return minDate;
    }

    init() { 
      this.picker = new easepick.create({
        element: this.input,
        css: [window.easepickCSS],
        zIndex: 10,
        firstDay: 0,
        autoApply: true,
        plugins: ['LockPlugin'],
        dateFormat: 'DD-MM-YYYY',
        format: 'DD-MM-YYYY',
        LockPlugin: {
          minDate: this.minDate,
          filter: (date, picked) => {
            return this.blockDates.includes(date.format('YYYY-MM-DD'));
          },
        },
        setup: (picker) => {
          picker.ui.wrapper.style.opacity = '0';
        },
      });

      this.input.addEventListener('focus', () => this.showAndStylePicker());

      this.picker.on('select', (event) => {
        this.classList.remove('error');
        this.updateCartDeliveryDate(event);
      });

      window.addEventListener('resize', () => {
        this.stylePickerElements();
      });

      this.stylePickerElements();

      if (this.clearDate || ( this.input.value !== '' && !this.validateDateString( this.formatDate(this.input.value, true) ))) {
        this.updateCartDeliveryDate(false);
        this.input.value = '';
      }
    }

    // TODO: This should happen on submit anyway - although it isn't
    // This needs to be resolved - but this can stay in place to persist the date as soon as the user changes it
    updateCartDeliveryDate(event) {
      let date = false;
      
      if (event && event.detail && event.detail.date) {
        date = event.detail.date;
      }

      // This shouldn't occur - but we abort just in case
      if (!date && event) {
        return;
      }

      const body = JSON.stringify({
        attributes: {
          delivery_date: date ? this.formatDate(date, true) : '',
        },
        sections: this.getSectionsToRender().map((section) => section.section),
      });

      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body },
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const freshSection = document.getElementById(section.id);
            const elementToReplace = freshSection
              ? freshSection.querySelector(section.selector)
              : document.getElementById(section.id);

            if (elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          });
        });
    }

    show() {
      this.picker && !this.picker.isShown() && this.input.focus() || this.picker.show();
    }

    stylePickerElements(render = true) {
      // Access the picker's shadow root if it has one
      if (this.picker?.ui?.shadowRoot) {
        const shadowRoot = this.picker.ui.shadowRoot;

        // Add the style tag to the shadow root if it doesn't exist
        if (this.styleTag && !this.hasStyleTag) {
          shadowRoot.appendChild(this.styleTag);
        }

        // Add override styles based off breakpoints;
        const override = {
          '.container:not(.inline).show': { transition: 'none' },
        };
        const container = override['.container:not(.inline).show'];

        if (window.innerWidth <= 480) {
          // this.picker.options.autoApply = false;

          container.top = '50%';
          container.transform = 'translate(50%, -50%)';
          container.left = 'auto';
          container.bottom = 'auto';
          container.right = '50vw';

          override['.day'] = {
            fontSize: '14px',
          };
        } else {
          // this.picker.options.autoApply = true;

          container.top = '100%';
          container.transform = 'translateX(-100%)';
          container.marginLeft = '100%';
        }

        this.applyStyleOverrides(override);

        // If it's cut off, we modify the styles and then reapply them
        if (this.isCutOff()) {
          container.top = 'auto';
          container.bottom = '100%';

          this.applyStyleOverrides(override);
        }

        if (render) {
          this.picker.renderAll();
        }
      }
    }

    showAndStylePicker() {
      this.picker.ui.wrapper.style.opacity = '0';

      if (this.picker.ui.container.classList.contains('show')) {
        this.stylePickerElements();
        this.picker.ui.wrapper.style.opacity = '1';
      } else {
        setTimeout(() => {
          this.showAndStylePicker();
        }, 30);
      }
    }

    validateDateString(dateString) {
      const inputTime = Date.parse(dateString);
      const minDateStr = this.minDate.toISOString().slice(0, 10);
      const minDateTime = Date.parse(minDateStr);

      return !isNaN(inputTime) && inputTime >= minDateTime;
    }

    isCutOff() {
      const containerElement = this.picker?.ui?.shadowRoot?.querySelector('.container');

      if (containerElement) {
        const rect = containerElement.getBoundingClientRect();
        return rect.bottom > window.innerHeight;
      }

      return false;
    }

    formatDate(date, reverse = false) {
      let day, month, year;

      if (typeof date === 'string') {
        
        if (date.match(/^\d{4}\-/)) {
          [year, month, day] = date.split('-');
        } else {
          [day, month, year] = date.split('-');
        }
      }

      if (typeof date === 'object') {
        year = date.getFullYear();
        month = String(date.getMonth() + 1).padStart(2, '0');
        day = String(date.getDate()).padStart(2, '0');
      }

      return reverse ? `${year}-${month}-${day}` : `${day}-${month}-${year}`;
    }

    applyStyleOverrides(override) {
      // Applies the styles as a CSS rule in the shadow root
      // This allows us to be more specific and override the default styles
      // All override styles get set as !important

      // Specific styles that can't be overridden by the CSS variables
      override['.footer-buttons'] = {
        justifyContent: 'space-between',
      };
      override['.footer-buttons > *'] = {
        fontSize: '15px',
        fontWeight: 'bold',
      };

      this.styleTag.textContent = `
            ${Object.entries(override)
              .map(
                ([className, styles]) =>
                  `${className} {\n` +
                  Object.entries(styles)
                    .map(([prop, val]) => `  ${prop.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${val} !important;`)
                    .join('\n') +
                  `\n}`
              )
              .join('\n')}
        `;
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        // {
        //   id: 'cart-icon-bubble',
        //   section: 'cart-icon-bubble',
        //   selector: '.shopify-section',
        // },
        {
          id: 'pre-checkout',
          section: 'pre-checkout',
          selector: '.pre-checkout__cart',
        },
      ];
    }
  }

  customElements.define('cart-delivery-date', CartDeliveryDate);
}
